// react-native-fs stand-in. The browser has no app-private filesystem; the
// document and recording services that use RNFS get a cloud-only web variant
// in Phase 5. Until then every path reports "not present" and writes fail
// loudly rather than silently, so a misrouted call is visible in the console.

const NOT_AVAILABLE = 'react-native-fs is not available on web';

export const CachesDirectoryPath = '/web/cache';
export const DocumentDirectoryPath = '/web/documents';
export const TemporaryDirectoryPath = '/web/tmp';
export const MainBundlePath = '/web';

export async function exists(_path: string): Promise<boolean> {
  return false;
}
export async function readFile(_path: string, _encoding?: string): Promise<string> {
  throw new Error(NOT_AVAILABLE);
}
export async function writeFile(_path: string, _contents: string, _encoding?: string): Promise<void> {
  throw new Error(NOT_AVAILABLE);
}
export async function unlink(_path: string): Promise<void> {}
export async function mkdir(_path: string): Promise<void> {}
export async function copyFile(_from: string, _to: string): Promise<void> {
  throw new Error(NOT_AVAILABLE);
}
export async function stat(_path: string): Promise<{ size: number; isFile: () => boolean }> {
  throw new Error(NOT_AVAILABLE);
}
export async function readDir(_path: string): Promise<unknown[]> {
  return [];
}

export default {
  CachesDirectoryPath,
  DocumentDirectoryPath,
  TemporaryDirectoryPath,
  MainBundlePath,
  exists,
  readFile,
  writeFile,
  unlink,
  mkdir,
  copyFile,
  stat,
  readDir,
};
